import { connect } from 'react-redux';
import { withAnalytics } from 'analytics';
import { favoriteStationToggle } from 'actions/favoriteStation-actions';
import { getIsFavoriteStation } from 'store/reducers/favorites';
import { saveRecentSearch } from 'actions/search-actions';
import CONTENT_TYPES from 'globalConst/contentTypes-const';
import { IHoverOverlay, DispatchToProps } from './HoverOverlay.interface';
import HoverOverlay from './HoverOverlay';
import { State } from 'redux';

interface OwnProps {
  station: {
    contentTypeId: string;
    slug: string;
    title: string;
    linkedPage: string;
    name: string;
    id: string;
    hasPage: boolean;
    collectionTitle: string;
  };
}

const mapStateToProps = (state: State, ownProps: OwnProps) => {
  return {
    station: ownProps.station,
    isFavorite: getIsFavoriteStation(state, ownProps.station),
  };
};

const favoriteStationToggleWithAnalytics = withAnalytics(favoriteStationToggle, {
  player_name: 'tile',
  link_id: CONTENT_TYPES.STATION_TILE,
});

const mapDispatchToProps = {
  onFavoriteToggle: favoriteStationToggleWithAnalytics,
  saveRecentSearch,
};

function mergeProps(
  stateProps: IHoverOverlay,
  { onFavoriteToggle, saveRecentSearch }: DispatchToProps,
  ownProps: OwnProps
) {
  const { station } = stateProps;
  return {
    ...ownProps,
    ...stateProps,
    saveRecentSearch,
    onFavoriteToggle: () => onFavoriteToggle(station),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(HoverOverlay);
